require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-meet-david-from-sworn-peace-officer-to-software-development-engineer-apprentice.json") })
        }
      }, "path---blog-meet-david-from-sworn-peace-officer-to-software-development-engineer-apprentice");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-meet-david-from-sworn-peace-officer-to-software-development-engineer-apprentice!./.cache/json/blog-meet-david-from-sworn-peace-officer-to-software-development-engineer-apprentice.json
// module id = 927
// module chunks = 231608221292675